import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function requestDeliveryDateChange({ 
  testWorkQueueId, 
  deliveryDate, 
  feedbackId,
  appointmentDate,
  printLabel,
  printerDepartment 
}) {
  const axios = axiosInstance().primoLab;
  
  try {
    const { data } = await axios.post('/clinic-deliveries/request-delivery-date-change', {
      test_work_queue_id: testWorkQueueId,
      delivery_date: deliveryDate,
      feedback_id: feedbackId,
      appointment_date: appointmentDate,
      print_label: printLabel,
      printer_department: printerDepartment,
    });
    return data;
  } catch (error) {
    const errorMessages = error.response?.data?.errors || error.response?.data?.message || ['Errore nell\'invio della richiesta'];
    throw new Error(Array.isArray(errorMessages) ? errorMessages.join(', ') : errorMessages);
  }
}

